/* ============================================================
   GoBrands - product page restructure

   Dawn renders the info column as a flat stack, which leaves the
   quantity stepper on its own row and the Buy-it-now button squeezed
   into whatever width Add-to-cart left over. This script rearranges
   it into a proper buy block:

     [ qty ][ ADD TO CART ]      <- .gb-buy, one row
     [   Buy it now          ]   <- lifted OUT of .gb-buy, full width
     [ delivery | genuine | support ]
     [ WhatsApp ][ Share ]       <- .gb-aux

   The assurance list must only carry claims the store actually honours.
   A size-exchange line was removed at the merchant's request - do not
   reintroduce returns or exchange wording here without asking.

   The WhatsApp link is injected by an app AFTER this script runs and
   carries hard inline styles (a full-width #25D366 slab), so it is
   picked up by an observer and its style attribute is stripped - CSS
   alone cannot beat an inline style without !important on every prop.
   ============================================================ */
(function () {
  if (window.__gbProduct) return;
  window.__gbProduct = true;

  var INFO = '.product__info-container';

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html) n.innerHTML = html;
    return n;
  }

  /* ---------- 1. buy row ----------
     The stepper and product-form are NOT siblings - Dawn nests the form
     inside an unclassed wrapper div. Inserting the row before `qty` using
     `form.parentNode` therefore threw NotFoundError and took the whole
     script down with it. Anchor on whichever element comes first, and
     insert into THAT element's own parent. */
  function buildBuy(info) {
    var qty = info.querySelector('.product-form__quantity');
    var form = info.querySelector('product-form') || info.querySelector('.product-form');
    if (!form || form.closest('.gb-buy')) return;

    var anchor = qty || form;
    var row = el('div', 'gb-buy');
    anchor.parentNode.insertBefore(row, anchor);
    if (qty) row.appendChild(qty);
    row.appendChild(form);

    // Buy it now belongs on its own full-width line, not inside the row
    var pay = form.querySelector('.shopify-payment-button');
    if (pay) row.parentNode.insertBefore(pay, row.nextSibling);
  }

  /* ---------- 2. assurances ---------- */
  function buildAssure(info) {
    if (info.querySelector('.gb-assure')) return;
    var anchor = info.querySelector('.gb-buy');
    if (!anchor) return;
    var after = info.querySelector('.shopify-payment-button') || anchor;
    if (!after.parentNode) after = anchor;

    var items = [
      ['M1 3h10v8H1zM11 6h3l1.5 2.5V11H11', 'Delivery all over Lebanon'],
      ['M8 1 2 3.5V8c0 3 2.6 5.6 6 6.5 3.4-.9 6-3.5 6-6.5V3.5z', 'Genuine brands only'],
      ['M14.5 7.6a6 6 0 0 1-8.6 5.4L2 14l1-3.6a6 6 0 1 1 11.5-2.8z', 'WhatsApp support 24/7']
    ];
    var wrap = el('ul', 'gb-assure');
    items.forEach(function (it) {
      var li = el('li', null,
        '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + it[0] + '"/></svg><span>' + it[1] + '</span>');
      wrap.appendChild(li);
    });
    after.parentNode.insertBefore(wrap, after.nextSibling);
  }

  /* ---------- 3. tidy the description ---------- */
  function tidyDescription(info) {
    var d = info.querySelector('.product__description');
    if (!d || d.dataset.gbTidy) return;
    d.dataset.gbTidy = '1';

    // a heading with no content under it renders as a stray label
    d.querySelectorAll('h1,h2,h3,h4,h5,h6,strong,p').forEach(function (n) {
      if (n.textContent.trim() === '' && !n.querySelector('img,svg,iframe')) n.remove();
    });
    d.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function (h) {
      var sib = h.nextElementSibling, has = false;
      while (sib && !/^H[1-6]$/.test(sib.tagName)) {
        if (sib.textContent.trim() !== '' || sib.querySelector('img,table')) { has = true; break; }
        sib = sib.nextElementSibling;
      }
      if (!has) h.remove();
    });

    // spec tables get their own scroll container
    d.querySelectorAll('table').forEach(function (t) {
      if (t.closest('.gb-spec')) return;
      var box = el('div', 'gb-spec');
      t.parentNode.insertBefore(box, t);
      box.appendChild(t);
    });
  }

  /* ---------- 4. WhatsApp + share into one row ---------- */
  function tidyAux(info) {
    var wa = info.querySelector('a[href*="wa.me"], a[href*="api.whatsapp"]');
    var share = info.querySelector('share-button');
    if (!wa && !share) return;

    var row = info.querySelector('.gb-aux');
    if (!row) {
      row = el('div', 'gb-aux');
      var anchor = info.querySelector('.gb-assure') || info.querySelector('.gb-buy');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(row, anchor.nextSibling);
      else info.appendChild(row);
    }
    if (wa && wa.parentNode !== row) {
      wa.removeAttribute('style');       // app ships a hard-coded green slab
      wa.classList.add('gb-wa');
      if (!wa.querySelector('svg')) {
        wa.innerHTML = '<svg viewBox="0 0 16 16" width="15" height="15" fill="currentColor" aria-hidden="true"><path d="M8 0a8 8 0 0 0-6.9 12L0 16l4.1-1.1A8 8 0 1 0 8 0m0 1.5A6.5 6.5 0 1 1 4.6 13.6l-.3-.2-2.4.6.7-2.3-.2-.3A6.5 6.5 0 0 1 8 1.5m3.6 8.2c-.2-.1-1.1-.6-1.3-.6s-.3-.1-.4.1-.5.6-.6.8-.2.1-.4 0a5.3 5.3 0 0 1-2.6-2.3c-.2-.3.2-.3.5-1 0-.1 0-.3-.1-.4L6.1 5c-.1-.3-.3-.3-.4-.3h-.4a.8.8 0 0 0-.6.3 2.3 2.3 0 0 0-.7 1.7 4 4 0 0 0 .9 2.1 9 9 0 0 0 3.4 3 4 4 0 0 0 2.4.5 2 2 0 0 0 1.3-.9 1.6 1.6 0 0 0 .1-.9z"/></svg><span>Ask on WhatsApp</span>';
      }
      row.appendChild(wa);
    }
    if (share && share.parentNode !== row) row.appendChild(share);
  }

  // each step is isolated: one failure must not take the others down with it
  function step(fn, info) {
    try { fn(info); } catch (e) { console.warn('[gb-product] ' + fn.name + ':', e); }
  }

  function run() {
    var info = document.querySelector(INFO);
    if (!info) return;
    step(buildBuy, info);
    step(buildAssure, info);
    step(tidyDescription, info);
    step(tidyAux, info);
  }

  function init() {
    run();
    var info = document.querySelector(INFO);
    if (!info) return;
    // the WhatsApp app and Dawn's variant re-render both mutate this column
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 60);
    }).observe(info, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
